import { axiosInstance } from "../../../hoc/Axios/Axios";
import * as actions from "../../Actions";

export const getActionsLogs = params => dispatch => axiosInstance
    .get("/action-logs", { params })
    .then(response => {
        dispatch({ type: actions.GET_ACTION_LOGS, payload: response.data.data })
    })
    .catch(() => null)
